import { render, staticRenderFns } from "./LoanDetails.vue?vue&type=template&id=340123cb"
import script from "./LoanDetails.vue?vue&type=script&lang=js"
export * from "./LoanDetails.vue?vue&type=script&lang=js"
import style0 from "./LoanDetails.vue?vue&type=style&index=0&id=340123cb&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('340123cb')) {
      api.createRecord('340123cb', component.options)
    } else {
      api.reload('340123cb', component.options)
    }
    module.hot.accept("./LoanDetails.vue?vue&type=template&id=340123cb", function () {
      api.rerender('340123cb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/modules/guest/new-applicant/components/steps/LoanDetails/LoanDetails.vue"
export default component.exports